import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Footer } from './components/footer/footer';
import { AppInstallBanner } from './components/app-install-banner/app-install-banner';

const BANNER_KEY = 'barbook_app_banner_dismissed';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Footer, AppInstallBanner],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit, OnDestroy {
  isHome = false;
  isDetail = false;

  // Banner
  showBanner = false;
  bannerIsIOS = false;
  bannerIsAndroid = false;
  private isMobile = false;
  private bannerTimer?: ReturnType<typeof setTimeout>;

  private routerSub?: Subscription;

  constructor(private router: Router, private cdr: ChangeDetectorRef) {}

  private detectMobile() {
    if (typeof navigator === 'undefined') return;
    const ua = navigator.userAgent;
    const uaMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
    const narrowScreen = typeof window !== 'undefined' && window.innerWidth < 768;
    this.isMobile = uaMobile || narrowScreen;
    this.bannerIsIOS = /iPhone|iPad|iPod/i.test(ua);
    this.bannerIsAndroid = /Android/i.test(ua);
  }

  ngOnInit() {
    this.detectMobile();
    this.checkRoute(this.router.url);
    this.tryShowBanner();
    this.routerSub = this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e) => {
        this.checkRoute((e as NavigationEnd).urlAfterRedirects);
        this.tryShowBanner();
      });
  }

  private tryShowBanner() {
    clearTimeout(this.bannerTimer);
    this.showBanner = false;
    if (!this.isMobile) return;
    if (localStorage.getItem(BANNER_KEY)) return;
    this.bannerTimer = setTimeout(() => {
      this.showBanner = true;
      this.cdr.detectChanges();
    }, 3000);
  }

  onBannerDismissed(event: { forever: boolean }) {
    this.showBanner = false;
    if (event.forever) {
      localStorage.setItem(BANNER_KEY, 'true');
    }
  }

  private checkRoute(url: string) {
    this.isHome = url === '/home' || url === '/';
    this.isDetail = url.startsWith('/bar/') || url.startsWith('/lists/');
  }

  ngOnDestroy() {
    clearTimeout(this.bannerTimer);
    this.routerSub?.unsubscribe();
  }
}
